/**
 * @fileoverview Utilitários para detecção de dispositivos móveis.
 * Permite otimizar a execução de hooks específicos por plataforma.
 * 
 * @module DeviceDetection
 * @since 1.0.0
 */

/**
 * Detecta se o dispositivo é móvel (iOS ou Android)
 * @returns {boolean} True se for dispositivo móvel
 */
export const isMobileDevice = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  
  // Detecta iOS
  const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  
  // Detecta Android
  const isAndroid = /android/i.test(userAgent);
  
  // Detecta mobile via media query como fallback
  const isMobileScreen = window.matchMedia('(max-width: 768px)').matches;
  
  return isIOS || isAndroid || isMobileScreen;
};

/**
 * Detecta se é desktop/notebook
 * @returns {boolean} True se for desktop
 */
export const isDesktopDevice = () => {
  return !isMobileDevice();
};

/**
 * Detecta especificamente iOS
 * @returns {boolean} True se for iOS
 */
export const isIOSDevice = () => {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
};

/**
 * Detecta especificamente Android
 * @returns {boolean} True se for Android
 */
export const isAndroidDevice = () => {
  return /android/i.test(navigator.userAgent);
};

/**
 * Hook personalizado para detecção de dispositivo
 * @returns {Object} Objeto com informações do dispositivo
 */
export const useDeviceDetection = () => {
  const isMobile = isMobileDevice();
  const isDesktop = isDesktopDevice();
  const isIOS = isIOSDevice();
  const isAndroid = isAndroidDevice();
  
  return {
    isMobile,
    isDesktop,
    isIOS,
    isAndroid
  };
};